import CheckGroup from '@components/molecules/CheckGroup';
import { VehicleUtilization, VehicleType } from '@graphql/generated';
import {
  QuoteInitialForm,
  VehicleUtilizationTypeFormResult,
} from '@lib/data/typesQuestions';
import GridBox from 'components/atoms/GridBox';
import OnboardingButtonBar from 'components/molecules/button-bar/OnboardingButtonBar';
import { FC } from 'react';
import { useForm } from 'react-hook-form';

interface FormResult {
  utilization: VehicleUtilization[];
}

interface Props {
  onSubmit: (data: VehicleUtilizationTypeFormResult) => void;
  loading: boolean;
  item: QuoteInitialForm;
}

const VehicleUtilizationForm: FC<Props> = ({ onSubmit, loading, item }) => {
  const { register, handleSubmit, errors } = useForm<FormResult>();

  const submit = ({ utilization }: FormResult) => {
    if (item.vehicle) {
      onSubmit({
        vehicle: {
          ...item.vehicle,
          utilization,
          workParking:
            utilization.includes(VehicleUtilization.Delivery) ||
            utilization.includes(VehicleUtilization.App) ||
            !utilization.includes(VehicleUtilization.Commuting) ||
            !utilization.includes(VehicleUtilization.Work)
              ? null
              : item.vehicle?.workParking,

          schoolParking: !utilization.includes(VehicleUtilization.School)
            ? null
            : item.vehicle?.schoolParking,
        },
      });
    }
  };

  const options = [
    {
      label: 'Lazer',
      value: VehicleUtilization.Leisure,
    },
    {
      label: 'Ir e voltar do trabalho',
      value: VehicleUtilization.Commuting,
    },
    {
      label: 'Ir e voltar da faculdade ou escola',
      value: VehicleUtilization.School,
    },
    {
      label: 'Entregas ou delivery',
      value: VehicleUtilization.Delivery,
    },
    {
      label: 'Visitar clientes ou fornecedores',
      example: '',
      value: VehicleUtilization.Work,
    },
    {
      label: 'Apps de transporte',
      example: '(Ex.: Uber, Cabify, 99)',
      value: VehicleUtilization.App,
    },

    {
      label: 'Trilhas ou competições',
      value: VehicleUtilization.Sport,
    },
  ].filter(({ value }) => {
    if (item.vehicle?.type === VehicleType.Car)
      return ![VehicleUtilization.Delivery, VehicleUtilization.Sport].includes(
        value,
      );

    if (item.vehicle?.type === VehicleType.Motorcycle)
      return ![VehicleUtilization.App].includes(value);

    return true;
  });
  return (
    <form onSubmit={handleSubmit(submit)}>
      <GridBox justifyContent="center">
        <GridBox width={[1, 1, 1]}>
          <CheckGroup
            inputRef={register({ required: 'Escolha uma das opções' })}
            name="utilization"
            errorMessage={(errors.utilization as any)?.message}
            options={options.map((o) => {
              if (item.vehicle?.utilization?.includes(o.value))
                return { ...o, checked: true };

              return o;
            })}
          />
        </GridBox>
      </GridBox>
      <OnboardingButtonBar loading={loading} />
    </form>
  );
};

export default VehicleUtilizationForm;
